import { CompanyService } from '../../services/company.service';
import { Message } from 'primeng/primeng';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Component, OnInit, Inject, Input} from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from 'rxjs';
import {PaymentService} from '../../services/payment.service';
import { Order } from '../../models/order';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { JobOffersService } from '../../services/job-offers.service';

@Component({
  selector: 'app-add-user-post-hired-dialog',
  templateUrl: './add-user-post-hired-dialog.component.html',
  styleUrls: ['./add-user-post-hired-dialog.component.css']
})
export class AddUserPostHiredDialogComponent implements OnInit {
  transactions: any;
  totalTransactions: number;
  loading: boolean;
  @Input() jobsOffer: any;
  email: string;
  form: FormGroup;

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(
    public dialogRef: MdDialogRef<AddUserPostHiredDialogComponent>,
    public dialog: MdDialog,
    public paymentService: PaymentService,
    private jobService: JobOffersService,
    private companyService: CompanyService,
    private fb: FormBuilder,
  ) {
    this.loading = true;
  }

  ngOnInit() {
    const padss = this.genPassword();
    this.loading = false;
    this.form = this.fb.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      email: [ null, Validators.compose([ Validators.required, Validators.pattern(this.emailRegex) ]) ],
      nit: ['', Validators.required],
      telephone: ['', Validators.required],
      password: [padss, Validators.required],
      job_id: [this.jobsOffer.id, Validators.required],
      jobcategory_id: ['', Validators.required],
    });
  }

  genPassword() {
     let text = '';
     const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

   for (let i = 0; i < 5; i++) {
       text += possible.charAt(Math.floor(Math.random() * possible.length));
   }
   return text;

  }

  findEmail() {
    const email =  this.form.value.email;
    console.log(email);
    this.companyService.getCompanyUser(email).subscribe(
      res => {
        this.form.controls['nit'].setValue(res.nit);
        this.form.controls['name'].setValue(res.name);
        this.form.controls['telephone'].setValue(res.telephone);
        this.form.controls['contact'].setValue(res.contact);
        this.form.controls['jobcategory_id'].setValue(res.industry);
        console.log(res);
      },
      error => {
        this.showInformation(error.message[0]);
      }
    );
 }

 findNit() {
  const nit = this.form.value.nit;
  console.log(nit);
  this.companyService.getCompany(nit).subscribe(
    res => {
      this.form.controls['nit'].setValue(res.nit);
      this.form.controls['name'].setValue(res.name);
      this.form.controls['telephone'].setValue(res.telephone);
      this.form.controls['contact'].setValue(res.contact);
      this.form.controls['jobcategory_id'].setValue(res.industry);
      console.log(res);
    },
    error => {
      this.showInformation(error.message[0]);
    }
  );
}

  onAddCompany(formAdd) {
    const pass = this.genPassword();
    this.jobService.postJobCompanyPost(formAdd).subscribe(
      res => {
        this.showInformation("Usuario creado satisfactoriamente");
        this.dialogRef.close();
      },
      error => {
        this.showInformation(error.message[0]);
      }
    );
  }

  showInformation(m) {
    this.dialog.open(MessageBoxDialog, {data: {message: m, information: true, showIcon: true}});
  }




}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/add-user-post-hired-dialog/add-user-post-hired-dialog.component.ts